module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    staticClass: "slider-home"
  }, [_c('swiper', {
    staticClass: "slider-home__slider",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.props), function(slide, i) {
    return _c('swiper-slide', {
      key: i,
      staticClass: "slider-home__slide"
    }, [_c('div', {
      staticClass: "slider-home__image",
      style: ("backgroundImage: url(" + slide.image + ");")
    })])
  })), _c('div', {
    staticClass: "slider-home__container-pagination"
  }, [_c('div', {
    staticClass: "slider-home__pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26a8757b","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/slider/slider-home/slider-home.pug
// module id = 626
// module chunks = 1